export default "__VITE_ASSET__7m1by0Ta__"